//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { isDefined } from '@utils/filterPredicates';

/**
 * Given an optional value that can be of any object type, checks that the given object exists and has the given property.
 */
export function hasProperty<
  O extends Record<PropertyKey, unknown>,
  P extends PropertyKey,
>(property: P, item?: O): item is O & Record<P, unknown> {
  return !!(item && isDefined(item[property]));
}

/**
 * Given an optional value of type unknown, checks that the given item is an object with the given property.
 */
export function isObjectWithProperty<P extends PropertyKey>(
  property: P,
  item?: unknown,
): item is Record<P, unknown> {
  return !!(
    item &&
    typeof item === 'object' &&
    hasProperty(property, item as Record<P, unknown>)
  );
}

export function isObjKey<T extends {}>(
  key: PropertyKey,
  obj: T,
): key is keyof T {
  return key in obj;
}
